import React from "react";
import "../../css/MenuMobile.css";

export default function Menu() {
  return (
    <div id="menu-container">
      <ul>
        <li>
          <a href="https://baalspots.com/" target="_blank" rel="noreferrer">
            Deposit
          </a>
        </li>
        <li>
          <a href="https://baalspots.com/" target="_blank" rel="noreferrer">
            Dashboard
          </a>
        </li>
        <li>
          <a href="https://baalspots.com/" target="_blank" rel="noreferrer">
            Company
          </a>
        </li>
        <li>
          <a href="https://baalspots.com/" target="_blank" rel="noreferrer">
            Pricing
          </a>
        </li>
      </ul>
    </div>
  );
}
